/*
 * Comportamiento de las tarjetas de producto (snippets/product-card-4.liquid): la fecha de
 * entrega (sl-delivery-date) y el scroll de la ficha en móvil (sl-spec-scroller, más abajo).
 *
 * Fecha de entrega:
 * «Recíbelo desde este jueves 15 de octubre». Es la primera fecha del envío programado del
 * mini-cart (window.PRECHECKOUT_CONFIG.scheduledDelivery en layout/theme.liquid): días de
 * anticipación según el día y si ya pasó la hora de corte en Lima, sin domingos ni feriados.
 * Se calcula en el navegador porque las páginas de colección quedan en caché. Sin JS queda el
 * texto del snippet. Es un custom element para que también funcione en las tarjetas que llegan
 * después (filtros, «Cargar más», recomendaciones).
 */
(() => {
  if (!window.customElements || customElements.get('sl-delivery-date')) return;

  const DEFAULTS = {
    cutoffHour: 21,
    leadDaysBeforeCutoff: { 0: 2, 1: 1, 2: 1, 3: 1, 4: 1, 5: 1, 6: 2 },
    leadDaysAfterCutoff: { 0: 2, 1: 2, 2: 2, 3: 3, 4: 2, 5: 3, 6: 2 },
    closedWeekdays: [0],
    holidays: [],
  };

  const LIMA_PARTS = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Lima',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    hourCycle: 'h23',
  });
  const WEEKDAY = new Intl.DateTimeFormat('es-PE', { timeZone: 'UTC', weekday: 'long' });
  const MONTH = new Intl.DateTimeFormat('es-PE', { timeZone: 'UTC', month: 'long' });

  // Fecha y hora actuales en Lima (UTC-5, sin horario de verano), sin depender de la zona
  // horaria del navegador.
  function limaNow() {
    const parts = {};
    LIMA_PARTS.formatToParts(new Date()).forEach(({ type, value }) => (parts[type] = value));
    return {
      date: new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day))),
      hour: Number(parts.hour) % 24,
    };
  }

  // Mismas reglas que scheduleDates() en assets/enova-minicart-checkout.js.
  function firstDeliveryDate() {
    const rules = Object.assign({}, DEFAULTS, (window.PRECHECKOUT_CONFIG || {}).scheduledDelivery);
    const now = limaNow();
    const lead = now.hour >= Number(rules.cutoffHour) ? rules.leadDaysAfterCutoff : rules.leadDaysBeforeCutoff;
    const date = new Date(now.date);
    date.setUTCDate(date.getUTCDate() + (Number(lead[date.getUTCDay()]) || 1));
    const closed = (rules.closedWeekdays || []).map(Number);
    const holidays = rules.holidays || [];
    for (let guard = 0; guard < 90; guard += 1) {
      if (!closed.includes(date.getUTCDay()) && !holidays.includes(date.toISOString().slice(0, 10))) return date;
      date.setUTCDate(date.getUTCDate() + 1);
    }
    return null;
  }

  class SlDeliveryDate extends HTMLElement {
    connectedCallback() {
      const date = firstDeliveryDate();
      if (date) {
        // Chrome escribe «Octubre» con es-PE; en español van en minúscula.
        const weekday = WEEKDAY.format(date).toLowerCase();
        const month = MONTH.format(date).toLowerCase();
        this.textContent = `Recíbelo desde este ${weekday} ${date.getUTCDate()} de ${month}`;
      }
    }
  }

  customElements.define('sl-delivery-date', SlDeliveryDate);

  // Ficha de características en móvil: una fila con scroll horizontal (enova.css). Marca
  // data-end cuando no queda nada a la derecha, para desvanecer el degradado y la flecha, y la
  // flecha avanza una característica.
  class SlSpecScroller extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.sl-card__specs');
      this.next = this.querySelector('.sl-card__specs-next');
      if (!this.list) return;
      this.update = () => this.toggleAttribute('data-end', this.list.scrollLeft + this.list.clientWidth >= this.list.scrollWidth - 2);
      this.onNext = () => {
        const step = this.list.firstElementChild ? this.list.firstElementChild.getBoundingClientRect().width : 130;
        this.list.scrollBy({ left: step, behavior: 'smooth' });
      };
      this.list.addEventListener('scroll', this.update, { passive: true });
      if (this.next) this.next.addEventListener('click', this.onNext);
      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.list);
      }
      this.update();
    }

    disconnectedCallback() {
      if (!this.list) return;
      this.list.removeEventListener('scroll', this.update);
      if (this.next) this.next.removeEventListener('click', this.onNext);
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('sl-spec-scroller', SlSpecScroller);
})();
